import * as imagesLoaded from 'imagesloaded'
import GsapSmoothScroll from './class/GsapSmoothScroll'

import common from './common'
import index from './index'
import firstview from './firstview'

document.addEventListener('DOMContentLoaded', function() {
  const load = document.getElementById('load')
  imagesLoaded(document.getElementById('app'), ()=>{
    if(load){
      load.style.opacity = 0
      setTimeout(()=>{
        load.remove()
        document.getElementById('firstview').classList.add('active')
      },1000)
    }
    let smoother
    setTimeout(()=>{
      if(window.innerWidth > 1119){
        smoother = new GsapSmoothScroll("#scrollArea", null, 1.6)
      }
      common()
      index()
      firstview()
      setProp()
    },100)

    function setProp(){
      if(smoother != null){
        document.documentElement.style.setProperty('--screen', `${smoother.getOffsets()}px`)
      }else{
        cancelAnimationFrame(setProp)
      }
      requestAnimationFrame(setProp)
    }
  })
});


